var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var session = require('../../auth/models/session');
var edit = require('../../layout/components/edit');

var pagination = {};

function searchableFieldValues(value) {
  if (typeof value === 'string') return [value];
  if (Array.isArray(value)) {
    return value.reduce(function (values, item) {
      return values.concat(searchableFieldValues(item));
    }, []);
  }
  return [];
}

function fieldSearchRank(value, query) {
  var values = searchableFieldValues(value).map(function (fieldValue) {
    return fieldValue.toLowerCase();
  }).filter(Boolean);

  if (values.some(function (fieldValue) { return fieldValue === query; })) return 0;
  if (values.some(function (fieldValue) { return fieldValue.indexOf(query) === 0; })) return 1;
  if (values.some(function (fieldValue) {
    return fieldValue.split(/\s+/).some(function (word) { return word === query; });
  })) return 2;
  if (values.some(function (fieldValue) { return fieldValue.indexOf(query) !== -1; })) return 3;
  return null;
}

function recordSearchRank(item, fieldsToSearch, query) {
  var bestRank = null;
  fieldsToSearch.forEach(function (field, fieldIndex) {
    var rank = fieldSearchRank(item && item[field], query);
    if (rank === null) return;
    var weightedRank = rank * 100 + fieldIndex;
    if (bestRank === null || weightedRank < bestRank) {
      bestRank = weightedRank;
    }
  });
  return bestRank;
}

pagination.oninit = function (vnode) {
  var ctrl = this;
  ctrl.randomId = Math.random().toString(36).substring(7);
  ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data || []));
  ctrl.filteredData = JSON.parse(JSON.stringify(vnode.attrs.data || []));
  ctrl.dataToShow = vnode.attrs.dataToShow;
  ctrl.placeHolder = vnode.attrs.placeHolder || "Search";
  ctrl.itemsPerPage = vnode.attrs.itemsPerPage || 10;
  ctrl.fieldsToSearch = vnode.attrs.fieldsToSearch || ['name'];
  ctrl.hideSearch = vnode.attrs.hideSearch || false;
  ctrl.filteredDataLength = vnode.attrs.filteredDataLength || prop();
  ctrl.redrawPending = false;
  ctrl.smallScreen = false;

  ctrl.vm = vnode.attrs.vm;
  ctrl.urlForRecord = vnode.attrs.urlForRecord;
  ctrl.search = prop('');
  ctrl.searchActive = prop(false);
  ctrl.notifyPageChange = function () {
    if (typeof vnode.attrs.onPageChange === 'function') {
      vnode.attrs.onPageChange(ctrl.dataToShow, ctrl.selectedPage());
    }
  };
  ctrl.updateSmallScreen = function (dom) {
    if (!dom) return;
    var isSmall = dom.clientWidth < 620;
    if (ctrl.smallScreen !== isSmall) {
      ctrl.smallScreen = isSmall;
      m.redraw();
    }
  };
  ctrl.scheduleRedraw = function() {
    if (ctrl.redrawPending) return;
    ctrl.redrawPending = true;
    setTimeout(function() {
      ctrl.redrawPending = false;
      m.redraw();
    }, 0);
  }
  ctrl.init = function() {
    ctrl.selectedPage = prop(1);
    ctrl.numberOfPages = prop(Math.ceil(ctrl.filteredData.length / ctrl.itemsPerPage));
    var newViewArray = ctrl.filteredData.slice(0, ctrl.itemsPerPage);
    ctrl.dataToShow.length = 0;
    ctrl.dataToShow.push(...newViewArray);
    if (ctrl.dataToShow.length < ctrl.itemsPerPage) {
      let numberFakeRecords = ctrl.itemsPerPage - ctrl.dataToShow.length;
      for (let index = 0; index < numberFakeRecords; index++) {
        ctrl.dataToShow.push({})
      }
    }
    ctrl.filteredDataLength(ctrl.filteredData.length);
    ctrl.notifyPageChange();
    ctrl.scheduleRedraw();
  }

  ctrl.init();

  ctrl.firstPage = function () {
    ctrl.selectedPage(1);
    ctrl.dataToShow.splice(0);
    ctrl.dataToShow.push(...ctrl.filteredData.slice((ctrl.selectedPage()-1)*ctrl.itemsPerPage, (((ctrl.selectedPage()-1)*ctrl.itemsPerPage+(ctrl.itemsPerPage-1))+1)));
    if (ctrl.dataToShow.length < ctrl.itemsPerPage) {
      let numberFakeRecords = ctrl.itemsPerPage - ctrl.dataToShow.length;
      for (let index = 0; index < numberFakeRecords; index++) {
        ctrl.dataToShow.push({})
      }
    }
    ctrl.notifyPageChange();
  }  
  ctrl.previusPage = function () {
    ctrl.selectedPage(ctrl.selectedPage() - 1);
    ctrl.dataToShow.splice(0);
    ctrl.dataToShow.push(...ctrl.filteredData.slice((ctrl.selectedPage()-1)*ctrl.itemsPerPage, (((ctrl.selectedPage()-1)*ctrl.itemsPerPage+(ctrl.itemsPerPage-1))+1)));
    if (ctrl.dataToShow.length < ctrl.itemsPerPage) {
      let numberFakeRecords = ctrl.itemsPerPage - ctrl.dataToShow.length;
      for (let index = 0; index < numberFakeRecords; index++) {
        ctrl.dataToShow.push({})
      }
    }
    ctrl.notifyPageChange();
  }
  ctrl.nextPage = function () {
    ctrl.selectedPage(ctrl.selectedPage() + 1);
    ctrl.dataToShow.splice(0);
    ctrl.dataToShow.push(...ctrl.filteredData.slice((ctrl.selectedPage()-1)*ctrl.itemsPerPage, (((ctrl.selectedPage()-1)*ctrl.itemsPerPage+(ctrl.itemsPerPage-1))+1)));
    if (ctrl.dataToShow.length < ctrl.itemsPerPage) {
      let numberFakeRecords = ctrl.itemsPerPage - ctrl.dataToShow.length;
      for (let index = 0; index < numberFakeRecords; index++) {
        ctrl.dataToShow.push({})
      }
    }
    ctrl.notifyPageChange();
  }
  ctrl.lastPage = function () {
    ctrl.selectedPage(ctrl.numberOfPages());
    ctrl.dataToShow.splice(0);
    ctrl.dataToShow.push(...ctrl.filteredData.slice((ctrl.selectedPage()-1)*ctrl.itemsPerPage, (((ctrl.selectedPage()-1)*ctrl.itemsPerPage+(ctrl.itemsPerPage-1))+1)));
    if (ctrl.dataToShow.length < ctrl.itemsPerPage) {
      let numberFakeRecords = ctrl.itemsPerPage - ctrl.dataToShow.length;
      for (let index = 0; index < numberFakeRecords; index++) {
        ctrl.dataToShow.push({})
      }
    }
    ctrl.notifyPageChange();
  }  
  ctrl.showPage = function (page) {
    ctrl.selectedPage(page);
    ctrl.dataToShow.splice(0);
    ctrl.dataToShow.push(...ctrl.filteredData.slice((ctrl.selectedPage()-1)*ctrl.itemsPerPage, (((ctrl.selectedPage()-1)*ctrl.itemsPerPage+(ctrl.itemsPerPage-1))+1)));
    if (ctrl.dataToShow.length < ctrl.itemsPerPage) {
      let numberFakeRecords = ctrl.itemsPerPage - ctrl.dataToShow.length;
      for (let index = 0; index < numberFakeRecords; index++) {
        ctrl.dataToShow.push({})
      }
    }
    ctrl.notifyPageChange();
  }
  ctrl.onSearch = function() {
    const q = (ctrl.search() || '').toString().toLowerCase();
    if (!q) {
      ctrl.filteredData.splice(0);
      ctrl.filteredData.push(...ctrl.originalData);
      ctrl.init();
      return;
    }
    ctrl.filteredData.splice(0);
    ctrl.filteredData.push(...ctrl.originalData
      .map(function (item, index) {
        return {
          item: item,
          index: index,
          rank: recordSearchRank(item, ctrl.fieldsToSearch, q)
        };
      })
      .filter(function (record) {
        return record.rank !== null;
      })
      .sort(function (a, b) {
        return (a.rank - b.rank) || (a.index - b.index);
      })
      .map(function (record) {
        return record.item;
      }));
    ctrl.init();
  }
  ctrl.firstDraw = false;
}

pagination.onupdate = function(vnode) {
  var ctrl = this;
  if (vnode.attrs.newNode()) {
    vnode.attrs.newNode(false);
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data));
    ctrl.filteredData = JSON.parse(JSON.stringify(vnode.attrs.data));
    ctrl.search = prop('');
    ctrl.init();
  }
  var nextSearch = vnode.attrs.search || '';
  if (vnode.attrs.hideSearch && nextSearch !== ctrl.search()) {
    ctrl.search(nextSearch);
    ctrl.onSearch();
  }
  window.onresize = m.redraw;
}

pagination.view = function(vnode) {
  var ctrl = this;
  return m('div', [
    m('div',[
      m('div.f4.flex.items-center.justify-between',[
        // Left side: search (default) or custom control when search hidden
        !ctrl.hideSearch ? 
          m('div.f4.flex.items-center',[
            m(`span.ba.b--blue.br2.ph1.flex.items-center.mr2.h2`, {
              id: 'paginationWithSearchSpan',
              class: ctrl.searchActive() ? 'paginationWithSearchSpanBig' : 'paginationWithSearchSpanSmall',
              onclick: (e) => {
                ctrl.searchActive(true);
                setTimeout(function() {
                  var wrapper = (e && e.currentTarget) ? e.currentTarget : document.getElementById('paginationWithSearchSpan');
                  var searchInput = wrapper ? wrapper.querySelector('input') : null;
                  if (searchInput) searchInput.focus();
                }, 1);
              }
            },[
              m('div.nowrap', {style: {display: (ctrl.searchActive() ? 'none' : 'block')}}, [
                m('i', {
                  id: 'equipment-paginated-table-search-icon',
                  class: 'blue f2 mh3 ion-search pointer',
                })
              ]),
              m('div.flex.items-center', {style: {display: (ctrl.searchActive() ? 'flex' : 'none')}}, [
                m('input.mh1.mv1.w4', {
                  id: 'paginated-table-search-input',
                  placeholder: ctrl.placeHolder,
                  value: ctrl.search(),
                  autocomplete: 'off',
                  autocorrect: 'off',
                  spellcheck: 'false',
                  oninput: function(ev) {
                    ctrl.search(ev.target.value); 
                    ctrl.onSearch();
                  },
                  onblur: (e) => {
                    if (ctrl.search() && ctrl.search().length == 0) {
                      ctrl.searchActive(false);
                    }
                    key.unbind('e', 'all');
                    key.unbind('e', 'home');
                    key('e', function () {
                      if (session.user().isSuperuser == 1) {
                        edit.vm.toggle();
                        m.redraw();
                      }
                    });
                  },
                  onfocusin: (e) => {
                    key.unbind('e');
                  }
                }),
                ctrl.search() && ctrl.search().length > 0 ? 
                  m('i', {
                    class: 'blue f4 mr1 ion-close-circled pointer',
                    onclick: (e) => {
                      ctrl.search('');
                      ctrl.searchActive(false);
                      ctrl.onSearch();
                    }
                  })
                :
                  ''
              ])
            ])
          ])
        : (vnode.attrs.secondFilterDOM ? vnode.attrs.secondFilterDOM : m('div')),
        // Right side: custom control when search shown, else empty
        !ctrl.hideSearch ? (vnode.attrs.secondFilterDOM ? vnode.attrs.secondFilterDOM : m('div')) : m('div')
      ])
    ]),
    m('div', {
      onclick: () => {
        ctrl.searchActive(false)
      }
    },[
      vnode.children,
    ]),
    m('div'+(ctrl.numberOfPages() > 1 ? '.flex.flex-wrap.pt2' : '.dn'),{
      id: 'tab-container'+ctrl.randomId,
      oncreate: function (vnode) {
        ctrl.updateSmallScreen(vnode.dom);
      },
      onupdate: function (vnode) {
        ctrl.updateSmallScreen(vnode.dom);
      }
    },[
      function () {
        if (ctrl.numberOfPages()>1) {
          return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.mb1', {
            onclick: function (e) {
              if (ctrl.selectedPage()!=1) {
                ctrl.firstPage()
              }
            }
          },[
            m('span', {'aria-hidden':'true'}, '«'),
          ])
        }
      }(),
      m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.mb1', {
        onclick: function(e) {
            if (ctrl.selectedPage()!=1) {
              ctrl.previusPage()
            }
          }
      },[
        m('span', {'aria-hidden':'true'}, '<'),
      ]),
      function () {
        var tabs=[]
        var list = function(page) {
          return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.mb1'+ (ctrl.selectedPage() == page ? ' bg-mid-gray' : ''), {
            onclick: function(e) {
              ctrl.showPage(page)
            }
          },[
            m('span', {'aria-hidden':'true'}, page),
          ])
        }
        if (!ctrl.smallScreen && ctrl.numberOfPages()<=7) {
          for (var i=0; i<ctrl.numberOfPages();i++) {
            tabs.push(list(i+1))
          }
          return tabs
        }else if (!ctrl.smallScreen) {
          if (ctrl.selectedPage()<4) {
            for (var i=0; i<7;i++) {
              tabs.push(list(i+1))
            } 
            return tabs
          }
          if (ctrl.selectedPage()>3 && (ctrl.numberOfPages()-2)>ctrl.selectedPage()) {
            tabs.push(list(ctrl.selectedPage()-3))
            tabs.push(list(ctrl.selectedPage()-2))
            tabs.push(list(ctrl.selectedPage()-1))
            tabs.push(list(ctrl.selectedPage()))
            tabs.push(list(ctrl.selectedPage()+1))
            tabs.push(list(ctrl.selectedPage()+2))
            tabs.push(list(ctrl.selectedPage()+3))
            return tabs
          }
          if ((ctrl.numberOfPages()-3)<ctrl.selectedPage()) {
            for (var i=6; i>=0; i--) {
              tabs.push(list(ctrl.numberOfPages()-i))
            } 
            return tabs
          }
        }else{
          tabs.push(list(ctrl.selectedPage()))
          return tabs
        }
      }(),
      m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.mb1', {
        onclick: function(e) {
          if (ctrl.selectedPage()!=ctrl.numberOfPages()) {
            ctrl.nextPage();
          }
        }
      },[
        m('span', {'aria-hidden':'true'}, '>'),
      ]),
      function () {
        if (ctrl.numberOfPages()>1) {
          return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.mb1', {
            onclick: function (e) {
              if (ctrl.selectedPage()!=ctrl.numberOfPages()) {
                ctrl.lastPage()
              }
            }
          },[
            m('span', {'aria-hidden':'true'}, '» ' + ctrl.numberOfPages()),
          ])
        }
      }()
    ])
  ])
}

module.exports = pagination;
